module.exports = __webpack_public_path__ + "5a18ad6e651357ca0013df8597d17b82.jpg";